/**
 * In-memory-only storage for the app JWT and Microsoft OAuth tokens.
 * These previously lived in localStorage, readable by any script running on
 * the page — an XSS anywhere in the app could read them straight out of
 * storage. Module-scoped variables instead: still readable by any JS
 * executing on the page while it runs, but gone on reload or in a new tab,
 * so there's nothing left in persistent storage for an injected script,
 * browser extension, or disk-level compromise to find later.
 *
 * Trade-off: a full page reload loses the session and sends the user back
 * through Hub SSO (see AuthContext's checkAuthStatus and Login.js's code
 * exchange). That's a deliberate, temporary cost of the frontend-only mitigation —
 * removing it fully requires the backend to issue an HttpOnly session
 * cookie instead of a bearer JWT, which is a separate, larger change.
 */

let appToken = null;
const msTokens = { accessToken: null, refreshToken: null, expiry: null };

export function getToken() {
  return appToken;
}

export function setToken(token) {
  appToken = token || null;
}

export function clearToken() {
  appToken = null;
}

export function getMicrosoftAccessToken() {
  return msTokens.accessToken;
}

export function getMicrosoftRefreshToken() {
  return msTokens.refreshToken;
}

export function getMicrosoftTokenExpiry() {
  return msTokens.expiry;
}

export function setMicrosoftTokens({ accessToken, refreshToken, expiry } = {}) {
  if (accessToken !== undefined) msTokens.accessToken = accessToken;
  if (refreshToken !== undefined) msTokens.refreshToken = refreshToken;
  if (expiry !== undefined) msTokens.expiry = expiry;
}

export function clearMicrosoftTokens() {
  msTokens.accessToken = null;
  msTokens.refreshToken = null;
  msTokens.expiry = null;
}
